import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  get_user_public_profile_data_action,
  invite_password_reset_confirm_user_action,
  sigin_user_action,
} from "../../../redux/_actions";
import { useSelector } from "react-redux";

function useInvitePasswordReset() {
  const [loading, setloading] = useState(false);
  const [formData, setformData] = useState({});
  const [formInputsError, setFormInputsError] = useState({});
  const [showPassword1, setshowPassword1] = useState(false);
  const [showPassword2, setshowPassword2] = useState(false);
  const [userProfileInfo, setUserProfileInfo] = useState({});

  const { userPublicProfileData } = useSelector(
    (state) => state.get_user_public_profile_data_reducer
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  //initiate form data and set uid and token
  React.useEffect(() => {
    let data = {
      uid: "",
      token: "",
      new_password1: "",
      new_password2: "",
    };
    data.uid = params?.uid;
    data.token = params?.token;
    setformData(data);

    let url = new URL(window.location.href);
    let user = url.searchParams.get("user");
    if (user) {
      getUserData(user);
    }
  }, [params]);

  React.useEffect(() => {
    if (userPublicProfileData?.data) {
      setUserProfileInfo(userPublicProfileData?.data);
    }
  }, [userPublicProfileData]);

  const getUserData = async (id) => {
    await dispatch(get_user_public_profile_data_action(id));
  };

  //submit password button
  const onResetPasswordClick = async () => {
    setloading(true);
    if (validateForm()) {
      const res = await dispatch(
        invite_password_reset_confirm_user_action(formData)
      );
      if (res) {
        let loginData = await dispatch(
          sigin_user_action({
            email:
              userProfileInfo?.user_details &&
              userProfileInfo.user_details?.email,
            password: formData.new_password1,
          })
        );
        if (loginData) {
          let navigateRoute = location?.state && location.state?.navigateRoute;
          if (navigateRoute) {
            navigate(navigateRoute, { state: location?.state });
          } else {
            navigate(-1);
          }
        }
      }
    }
    setloading(false);
  };

  // show/hide passwords
  const onShowPasswordClick = (key) => {
    switch (key) {
      case "new_password1":
        setshowPassword1(!showPassword1);
        break;
      case "new_password2":
        setshowPassword2(!showPassword2);
        break;
      default:
        return;
    }
  };

  //set passwords on input change
  const onInputChange = (value, key) => {
    let data = formData;
    data[key] = value;
    setformData(data);
  };

  //validate form
  const validateForm = () => {
    let form_errors = {};

    // validate passwords
    if (formData.new_password1.length === 0) {
      form_errors = {
        new_password1: "Field cannot be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }
    if (formData.new_password2.length === 0) {
      form_errors = {
        new_password2: "Field can not be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }
    if (formData.new_password2 !== formData.new_password1) {
      form_errors = {
        new_password2: "Both passwords do not match",
      };
      setFormInputsError(form_errors);
      return false;
    }
    return true;
  };

  //go back button
  const onBackClick = () => {
    navigate(-1);
  };
  const onLoginClick = () => {
    navigate("/sign-in", { state: location?.state });
  };

  return {
    loading,
    userProfileInfo,
    showPassword1,
    showPassword2,
    formInputsError,

    onShowPasswordClick,
    onResetPasswordClick,
    onInputChange,
    onBackClick,
    onLoginClick,
  };
}

export default useInvitePasswordReset;
